<template>
	<div class="app-container gamesProject">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>

			<el-button type="primary" icon="el-icon-plus" @click="handleAdd" class="mb20">添加赛事项目</el-button>
			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="赛事图标" align="center" prop="itemImg">
					<template slot-scope="scope">
						<el-image fit="contain" class="tableImg" :src="scope.row.itemImg"
							:preview-src-list="[scope.row.itemImg]">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="项目名称" align="center" prop="itemName" />
				<el-table-column label="添加人" align="center" prop="createBy" />
				<el-table-column label="添加时间" align="center" prop="createTime"></el-table-column>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />
		</el-card>

		<el-dialog :title="dialogTit" :visible.sync="dialogShow" width="600px" append-to-body>
			<el-form ref="setform" :model="setParams" size="mini" :rules="rules">
				<el-form-item label="赛事项目名称" prop="itemName">
					<el-input clearable size="small" style="width: 400px" placeholder="请输入赛事项目名称"
						v-model="setParams.itemName" />
				</el-form-item>
				<div class="coverUpload">
					<el-form-item label=" 赛事项目图标:" prop="itemImg" class="small" ref="upload">
						<div :class="{'got': !!setParams.itemImg}">
							<el-upload :limit="1" :action="action" :file-list="fileList" list-type="picture-card"
								accept=".jpg, .png, .jpeg" :on-preview="handlePreview" :on-success="changeCover"
								:headers="headers"
								:on-remove="removeCover">
								<i class="el-icon-plus"></i>
								<span class="uploadNote">上传图片</span>
							</el-upload>
						</div>
						<div class="sizeNote"> 说明：请上传150x150像素的png透明图标</div>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="dialogShow = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as API_Game from "@/api/sportManage/game";
	import store from "@/store/index";
	export default {
		name: "gamesProject",
		data() {
			return {
				pageName: '项目列表',
				action: process.env.VUE_APP_BASE_API + "/api/file/uploadOss",
				headers: {
					system: 0,
					token: store.state.token,
				},
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,

				dialogTit: "编辑赛事项目",
				setParams: {},
				rules: {
					itemName: [{
						required: true,
						message: "请输入赛事项目名称",
						trigger: "blur"
					}],
					itemImg: [{
						required: true,
						message: "请上传赛事项目图标",
						trigger: "change"
					}],
				},
				dialogShow: false,
				fileList: [],
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.queryParams.gameTypeId = this.$route.query.id;
			// this.pageName = this.$route.query.name + '-项目列表'
			this.pageName = '赛事项目列表'
			this._getList()
		},
		methods: {
			// 接口-赛事项目列表
			_getList() {
				this.loading = true
				API_Game.projectList(this.queryParams).then((res) => {
					console.log(res.data);
					this.loading = false
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 接口-新增赛事项目
			_addProject() {
				API_Game.addProject(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-编辑赛事项目
			_editProject() {
				API_Game.editProject(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-删除赛事项目
			_delProject(id) {
				API_Game.delProject(id).then((res) => {
					console.log(res.data);
					this.$message({
						message: "已删除",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},

			handleRefresh() {
				this.queryParams.pageNum = 1;
				this._getList();
				this.dialogShow = false
				this.fileList = []
			},
			handleAdd() {
				this.dialogShow = true;
				this.clear()
				this.fileList = []
				this.setParams = {
					gameTypeId: this.id,
				};
				this.dialogTit = '添加赛事项目'
			},
			handleEdit(row) {
				this.dialogShow = true
				this.clear();
				this.dialogTit = '编辑赛事项目'
				this.setParams = JSON.parse(JSON.stringify(row));
				this.fileList = [{
					name: '',
					url: row.itemImg
				}]
			},
			handleDel(row) {
				this.$confirm(`确定删除项目“${row.itemName}”？`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delProject(row.id)
					})
					.catch(() => {});
			},
			submitForm() {
				console.log(this.setParams)
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this.dialogShow = false
						this.clear()
						this.setParams.id ? this._editProject() : this._addProject()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			handlePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			changeCover(e) {
				console.log(e)
				this.setParams.itemImg = e.data.url
				this.$nextTick(() => {
					this.$refs.upload.clearValidate();
				})
				// this.$refs['setform'].clearValidate();
				// this.$refs.setform.validateField('itemImg');
				this.$forceUpdate()
			},
			removeCover() {
				this.setParams.itemImg = ''
				this.$forceUpdate()
			},
			// 弹窗-取消
			cancel() {
				this.setParams = {}
				this.dialogShow = false
				this.clear()
			},
			clear() {
				this.$nextTick(() => {
					this.$refs['setform'].clearValidate();
				})
			}
		},
	};
</script>

<style lang="scss">
	.gamesProject {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>


<style lang="scss">
	@import "../../../assets/styles/common.scss";
</style>